// extracted by mini-css-extract-plugin
export default {"section":"MainSection_section__NhuHA","title":"MainSection_title__Jk5rM","date":"MainSection_date__xq+JI","content":"MainSection_content__+Whlj"};